const useProjectEntity = (entity) => {
  const projectSlug = entity.metadata?.annotations?.["github.com/project-slug"];
  return {
    owner: projectSlug.split("/")[0],
    repo: projectSlug.split("/")[1]
  };
};

export { useProjectEntity };
//# sourceMappingURL=useProjectEntity.esm.js.map
